import { Map as IMap, Set as ISet } from 'immutable';
import { createSelector } from 'reselect';

import {
    AMOUNT_FIELD,
    FACEPLATE_FIELD,
    IS_PLASTIC_FIELD,
    PROGRAM_CODE,
    IS_SELFBUY_FIELD,
    RECIPIENT_NAME_FIELD,
    SENDER_NAME_FIELD,
    SENDER_EMAIL_FIELD,
    RECIPIENT_EMAIL_FIELD,
    MESSAGE_FIELD, CURRENCY_FIELD
} from '../constants/constants';

import {
    PREFERRED_CLASSIC_GIFT,
    PREFERRED_FACEPLATE_CATEGORY
} from './flowProgressModule';

import {
    getMaxTransactionAmount,
    getFixedEgcCatalog,
    getFixedPlasticCatalog,
    getEgcRangedCatalog, getPlasticRangedCatalog
} from '../brand/brandSelectors';
import { getSubTotal } from '../productCartHandler/productCartSelectors';

export const getFlowProgressState = state => state.get('flowProgress', IMap());

export const getFlowProgress = createSelector(
    getFlowProgressState,
    flowProgress => flowProgress.get('progress', ISet())
);

export const getPreferredValues = createSelector(
    getFlowProgressState,
    flowProgress => flowProgress.get('preferredValues', IMap())
);

export const getPreferredPaymentValues = createSelector(
    getFlowProgressState,
    flowProgress => flowProgress.get('preferredPaymentValues', IMap())
);

export const getStorefrontFlowIsPDP = createSelector(
    getFlowProgressState,
    flowProgress => flowProgress.get('isPDPFlow', false)
);

export const getIsSmartFlow = createSelector(
    getPreferredValues,
    values => (values ? values.get('isSmartFlow', false) : null)
);

export const getPreferredAmount = createSelector(
    getPreferredValues,
    values => (values ? values.get(AMOUNT_FIELD, 0) : 0)
);

export const getPreferredFaceplateCode = createSelector(
    getPreferredValues,
    values => (values ? values.get(FACEPLATE_FIELD, null) : null)
);

export const getPreferredCardType = createSelector(
    getPreferredValues,
    values => (values ? values.get(IS_PLASTIC_FIELD, null) : null)
);

export const getPreferredCurrencyCode = createSelector(
    getPreferredValues,
    values => (values ? values.get(CURRENCY_FIELD, null) : null)
);

export const getPreferredFaceplateCategory = createSelector(
    getPreferredValues,
    values => (values ? values.get(PREFERRED_FACEPLATE_CATEGORY, null) : null)
);

export const getPreferredClassicGift = createSelector(
    getPreferredValues,
    values => (values ? values.get(PREFERRED_CLASSIC_GIFT, null) : null)
);

export const getPreferredProgramCode = createSelector(
    getPreferredValues,
    values => (values ? values.get(PROGRAM_CODE, null) : null)
);

export const getPreferredLoyaltyNumber = createSelector(
    getPreferredPaymentValues,
    preferredPaymentValues => preferredPaymentValues.get('loyaltyNumber', null)
);

export const getPreferredSelfBuy = createSelector(
    getPreferredValues,
    values => (values ? values.get(IS_SELFBUY_FIELD, null) : null)
);

export const getPreferredRecipientName = createSelector(
    getPreferredValues,
    values => (values ? values.get(RECIPIENT_NAME_FIELD, null) : null)
);

export const getPreferredSenderName = createSelector(
    getPreferredValues,
    values => (values ? values.get(SENDER_NAME_FIELD, null) : null)
);

export const getPreferredSenderEmail = createSelector(
    getPreferredValues,
    values => (values ? values.get(SENDER_EMAIL_FIELD, null) : null)
);

export const getPreferredRecipientEmail = createSelector(
    getPreferredValues,
    values => (values ? values.get(RECIPIENT_EMAIL_FIELD, null) : null)
);

export const getPreferredMessage = createSelector(
    getPreferredValues,
    values => (values ? values.get(MESSAGE_FIELD, null) : null)
);

export const getFlowMessage = createSelector(
    getFlowProgressState,
    flowProgress => flowProgress.get('flowMessage', null)
);

export const getIsPreferredAmountValid = createSelector(
    getPreferredAmount,
    getPreferredCurrencyCode,
    getMaxTransactionAmount,
    getSubTotal,
    getFixedEgcCatalog,
    getFixedPlasticCatalog,
    getPreferredCardType,
    getEgcRangedCatalog,
    getPlasticRangedCatalog,
    (
        preferredAmount,
        preferredCurrency,
        maxTransaction,
        subtotal,
        fixedEgcDenoms,
        fixedPlasticDenoms,
        isPlastic,
        catalogRange,
        plasticCatalogRange
    ) => {
        const fixedDenomsList = isPlastic ? fixedPlasticDenoms : fixedEgcDenoms;
        const RangedDenomsList = isPlastic ? plasticCatalogRange : catalogRange;
        const withinMaxLimit = amount => maxTransaction.gte(subtotal.plus(amount));

        

        
        if (!!Number(preferredAmount) && !!preferredCurrency) {
            
            if (fixedDenomsList.size > 0) {
                if (fixedDenomsList.some(item => item.eq(Number(preferredAmount)))) {
                    return withinMaxLimit(Number(preferredAmount));
                }
                return false;
            }
            
            const minDenomination = RangedDenomsList.get('start');
            const maxDenomination = RangedDenomsList.get('end');
            if (Number(preferredAmount) >= Number(minDenomination) && Number(preferredAmount) <= Number(maxDenomination)) {
                return withinMaxLimit(Number(preferredAmount));
            }
        }
        return false;
    }
);
